import * as React from 'react';

// Components
import Box from '../../components/Box';
import Typography from '../../components/Typography';

// Component
interface IProps {
}

class ConfirmStep extends React.Component<IProps, {}> {
    render() {
        return (
            <Box pa={4} style={{ height: 176, textAlign: 'center' }}>
                <Box pt={5}>
                    <Typography type="headline">Ready to join?</Typography>
                    <Typography type="subheading" color="textSecondary">
                        Let's get started...
                    </Typography>
                </Box>
            </Box>
        );
    }
}

export default ConfirmStep;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/App/NetworksDialogJoinConfirm.tsx